import SkeletonBody, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './index.module.scss';

const Skeleton = ({ themeProps, ...rest }) =>
  themeProps ? (
    <SkeletonTheme {...themeProps}>
      <SkeletonBody {...rest} />
    </SkeletonTheme>
  ) : (
    <SkeletonBody baseColor="var(--user-neutral-2)" highlightColor="var(--user-inner-card-bg)" {...rest} />
  );

export default Skeleton;
